import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';
import { trackMetaPageView } from '@/lib/metaPixel';

/**
 * Fires a GA `page_view` and a Meta Pixel `PageView` on every SPA route
 * change. Mounted once inside <BrowserRouter>. Skips admin routes —
 * internal navigation doesn't belong in marketing analytics.
 */
export function RouteTracker(): null {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return;
    // Defer one tick so the destination page can update document.title
    // before we read it for the page_view payload.
    const id = window.setTimeout(() => {
      const path = location.pathname + location.search;
      trackPageView(path);
      trackMetaPageView(path);
    }, 0);
    return () => window.clearTimeout(id);
  }, [location.pathname, location.search]);

  return null;
}
